<template>
  <div id="app">
    <!-- <TranscriptEditor/> -->
    <router-view/>
  </div>
</template>

<script>
// import TranscriptEditor from './views/TranscriptEditor.vue'

export default {
  name: 'App',
  components: {
    // TranscriptEditor
  }
}
</script>

<style>
#app {
  font-family: system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
